<template>
  <div>
    <base-header class="pb-6 pb-6 pt-5 pt-md-8 bg-dark">
      <hr />
      <!-- Card stats
    <b-row>
    </b-row> -->
    </base-header>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col>
          <b-card>
            <!-- <vue-good-table
              :columns="columns"
              :line-numbers="false"
              styleClass="order-table vgt-table"
              :rows="getCatalogoProductos"
            >
            </vue-good-table> -->
            <vue-good-table
              :columns="columns"
              :line-numbers="false"
              :search-options="{
                enabled: true,
                placeholder: 'Buscar en los registros'
              }"
              :pagination-options="{
                enabled: true,
                mode: 'records',
                perPage: 15,
                perPageDropdown: [15, 25, 50],
                dropdownAllowAll: false,
                setCurrentPage: 2,
                nextLabel: 'Siguiente',
                prevLabel: 'Anterior',
                rowsPerPageLabel: 'Registros por página',
                ofLabel: 'de',
                pageLabel: 'páginas', // for 'pages' mode
                allLabel: 'All'
              }"
              styleClass="tableOne text-left vgt-table condensed"
              :selectOptions="{
                enabled: false,
                selectionInfoClass: 'table-alert__box'
              }"
              :fixed-header="true"
              row-style-class="text-left"
              :rows="rows"
            >
              <div slot="table-actions" class="mb-3">
                <b-button
                  to="/catalogos/sucursales/nuevo"
                  variant="primary"
                  class="btn-rounded"
                >
                  Agregar
                </b-button>
                <!-- <b-btn @click="apiGetCatalogoProductos" variant="primary">Productos</b-btn> -->
              </div>
            </vue-good-table>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      columns: [
        {
          label: "ID",
          field: "id",
          thClass: "text-left pl-3",
          tdClass: "text-left pl-3"
        },
        {
          label: "Código",
          field: "codigo",
          thClass: "text-left pl-3",
          tdClass: "text-left pl-3"
        },
        {
          label: "Nombre",
          field: "nombre",
          thClass: "text-left pl-3",
          tdClass: "text-left pl-3"
        },
        {
          label: "Domicilio",
          field: "domicilio",
          html: true,
          thClass: "text-center pl-3",
          tdClass: "text-center pl-3"
        },
        {
          label: "State",
          field: "cancel",
          html: true,
          thClass: "text-center pl-3",
          tdClass: "text-center pl-3"
        },
        {
          label: "Acciones",
          field: "button",
          html: true,
          tdClass: "text-right table-acciones",
          thClass: "text-right"
        }
      ],
      rows: []
    };
  },
  beforeMount() {
    this.getProductos();
  },
  computed: {},
  methods: {
    getProductos() {
      this.$api
        .get("productos")
        .then(response => {
          if (response.status == 200) {
            this.rows = response.data;
          }
        })
        .catch(e => console.error(e));
    }
  }
};
</script>
